<template>
    <div id="configInfo" class="configInfo">
        <!-- Tabs标签页 -->
        <el-tabs value="1" type="border-card">
            <!-- 只需一个标签页tab-pane -->
            <el-tab-pane :label="editableTabs[0].title" :name="editableTabs[0].name">
                <div class="config-container">
                    <!-- 通用的配置选项列表 -->
                    <ul class="general-config-list">
                        <li>
                            <div class="left-title">转换方式：</div>
                            <div class="radio-container">
                                <el-radio-group size="mini" v-model="convertWay">
                                    <el-radio-button label="lod" :disabled="isLodDisabled" @click.native="lodConvert">流式</el-radio-button>
                                    <el-radio-button label="obv" :disabled="isObvDisabled" @click.native="obvConvert">全量</el-radio-button>
                                </el-radio-group>
                            </div>
                        </li>
                    </ul>
                    <!-- 不同格式不同的配置选项列表 -->
                    <!-- rvt格式 -->
                    <ul class="format-config-list" v-if="fileFormat === 'rvt'">
                        <li>
                            <div class="left-title">着色类型：</div>
                            <div class="radio-container">
                                <el-radio-group size="mini" v-model="rvtFormat.shadeType">
                                    <el-radio-button label="shaded">着色</el-radio-button>
                                    <el-radio-button label="realistic">真实</el-radio-button>
                                </el-radio-group>
                            </div>
                        </li>
                        <li>
                            <div class="left-title">视图名称：</div>
                            <div class="radio-container">
                                <el-radio-group size="mini" v-model="viewNameValue" @change="updateViewName">
                                    <el-radio-button label="default">默认</el-radio-button>
                                    <el-radio-button label="custom">自定义</el-radio-button>
                                </el-radio-group>
                            </div>
                            <div class="custom-input" v-if="viewNameValue === 'custom'">
                                <el-input
                                    v-model="rvtFormat.customInput"
                                    @input="updateViewName"
                                    size="mini"
                                    placeholder="例：三维视图 {三维}"
                                ></el-input>
                            </div>
                        </li>
                        <li>
                            <div class="left-title">详细等级：</div>
                            <div class="radio-container">
                                <el-radio-group size="mini" v-model="rvtFormat.lod">
                                    <el-radio-button label="rough">粗略</el-radio-button>
                                    <el-radio-button label="medium">中等</el-radio-button>
                                    <el-radio-button label="detail">详细</el-radio-button>
                                </el-radio-group>
                            </div>
                        </li>
                    </ul>
                    <!-- ifc格式 -->
                    <ul class="format-config-list" v-if="fileFormat === 'ifc'">
                        <li>
                            <div class="left-title">合并零件为构件：</div>
                            <div class="switch-container">
                                <el-switch v-model="ifcFormat.assembly" active-color="#409EFF" inactive-color="#C0CCDA">
                                </el-switch>
                            </div>
                        </li>
                        <li>
                            <div class="left-title">不导出边线数据：</div>
                            <div class="switch-container">
                                <el-switch
                                    v-model="ifcFormat.noedgeline"
                                    active-color="#409EFF"
                                    inactive-color="#C0CCDA"
                                >
                                </el-switch>
                            </div>
                        </li>
                        <li>
                            <div class="left-title">导出贴图：</div>
                            <div class="switch-container">
                                <el-switch
                                    v-model="ifcFormat.exportTexture"
                                    active-color="#409EFF"
                                    inactive-color="#C0CCDA"
                                >
                                </el-switch>
                            </div>
                        </li>
                    </ul>
                    <!-- nwd格式 -->
                    <ul class="format-config-list" v-if="fileFormat === 'nwd'">
                        <li>
                            <div class="left-title">重新计算UV：</div>
                            <div class="switch-container">
                                <el-switch v-model="nwdFormat.recalcuv" active-color="#409EFF" inactive-color="#C0CCDA">
                                </el-switch>
                            </div>
                        </li>
                        <li>
                            <div class="left-title">执行顶点合并：</div>
                            <div class="switch-container">
                                <el-switch
                                    v-model="nwdFormat.mergevertex"
                                    active-color="#409EFF"
                                    inactive-color="#C0CCDA"
                                >
                                </el-switch>
                            </div>
                        </li>
                        <li>
                            <div class="left-title">不导出边线数据：</div>
                            <div class="switch-container">
                                <el-switch
                                    v-model="nwdFormat.noedgeline"
                                    active-color="#409EFF"
                                    inactive-color="#C0CCDA"
                                >
                                </el-switch>
                            </div>
                        </li>
                    </ul>
                    <!-- skp格式 -->
                    <ul class="format-config-list" v-if="fileFormat === 'skp'">
                        <li>
                            <div class="left-title">是否导出边线：</div>
                            <div class="switch-container">
                                <el-switch
                                    v-model="skpFormat.isExportLineSet"
                                    active-color="#409EFF"
                                    inactive-color="#C0CCDA"
                                >
                                </el-switch>
                            </div>
                        </li>
                    </ul>
                    <!-- dwg格式 -->
                    <ul class="format-config-list" v-if="fileFormat === 'dwg'">
                        <li>
                            <div class="left-title">视图类型：</div>
                            <div class="radio-container">
                                <el-radio-group size="mini" v-model="dwgFormat.viewType">
                                    <el-radio-button label="v2d">二维图纸</el-radio-button>
                                    <el-radio-button label="v3d">三维模型</el-radio-button>
                                </el-radio-group>
                            </div>
                        </li>
                    </ul>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
export default {
    name: 'configTabs',
    data() {
        return {
            // tabs面板的页，目前只有一页
            editableTabs: [
                {
                    title: '转换配置',
                    name: '1',
                },
            ],
            isObvDisabled: '', //是否禁用obv(全量)转换
            isLodDisabled: '', //是否禁用LOD转换
            convertWay: '', // 通用转换方式
            viewNameValue: 'default', // 视图名称单选按钮的label
            // rvt中的选项
            rvtFormat: {
                viewName: '', // 视图名称的值
                shadeType: '',
                lod: '',
                customInput: '',
            },
            // ifc中的选项
            ifcFormat: {
                assembly: '',
                noedgeline: '',
                exportTexture: '',
            },
            // nwd中的选项
            nwdFormat: {
                recalcuv: '',
                noedgeline: '',
                mergevertex: '',
            },
            // skp中的选项
            skpFormat: {
                isExportLineSet: '',
            },
            // dwg中的选项
            dwgFormat: {
                viewType: '',
            },
        };
    },
    props: {
        fileFormat: String,
    },
    methods: {
        // 查询该格式是否拥有obv或lod转换
        isHasJobTypes() {
            this.isObvDisabled = true;
            this.isLodDisabled = true;
            let tempConverters = this.$store.state.fileConvert.converterTypes[this.fileFormat].converters; // 拿到对应格式converters数组
            for (let index = 0; index < tempConverters.length; index++) {
                let tempType = tempConverters[index].name.split('-');
                if (tempType[tempType.length - 1] === 'obv') {
                    this.isObvDisabled = false; // 如果拥有obv(全量)则不禁用
                }
                if (tempType[tempType.length - 1] === 'lod') {
                    this.isLodDisabled = false; // 如果拥有lod(流式)则不禁用
                }

                if(this.fileFormat === 'nwd') {
                  document.getElementsByClassName('format-config-list')[0].hidden = true;
                  this.convertWay = 'lod';
                }
            }
        },
        setConvertWay() {
            let tempConverters = this.$store.state.fileConvert.converterTypes[this.fileFormat].converters; // 拿到对应格式converters数组
            const hasLod = tempConverters.some(item => item.name.slice(-3) === 'lod');
            return  hasLod ? 'lod': 'obv';
        },
        // 重置为默认配置
        reDefault() {
            // 通用配置
            this.convertWay = this.setConvertWay();
            // rvt相关配置
            this.viewNameValue = 'default'; // 用来控制按钮与输入框的行为
            this.rvtFormat.viewName = 'default';
            this.rvtFormat.shadeType = 'shaded';
            this.rvtFormat.lod = 'rough';
            this.rvtFormat.customInput = '';
            // ifc相关配置
            this.ifcFormat.assembly = false;
            this.ifcFormat.noedgeline = false;
            this.ifcFormat.exportTexture = false;
            // nwd相关配置
            this.nwdFormat.noedgeline = false;
            this.nwdFormat.recalcuv = true;
            this.nwdFormat.mergevertex = true;
            // skp相关配置
            this.skpFormat.isExportLineSet = false;
            // dwg相关配置
            this.dwgFormat.viewType = 'v2d';
            // if (this.fileFormat === 'dwg') {
                //this.updateIsLodDisabled();
            // }
            // tifzip相关配置
            if (this.fileFormat === 'tifzip') {
                this.convertWay = 'lod';
            }
        },
        // dwg格式lod选项禁用
        // updateIsLodDisabled() {
        //     if (this.dwgFormat.viewType === 'v2d') {
        //         this.convertWay = 'obv';
        //         this.isLodDisabled = true;
        //     } else {
        //         this.isLodDisabled = false;
        //     }
        // },
        // 监听并读取视图名称自定义输入内容
        updateViewName() {
            if (this.viewNameValue === 'custom') {
                this.rvtFormat.viewName = this.rvtFormat.customInput;
            } else {
                this.rvtFormat.viewName = 'default';
            }
        },

        // 封装不同格式配置参数parameters的方法
        // rvt格式
        getRvtParameters() {
            const parameters = [
                {
                    key: '-viewname',
                    value: this.rvtFormat.viewName,
                },
                {
                    key: '-shadetype',
                    value: this.rvtFormat.shadeType,
                },
                {
                    key: '-lod',
                    value: this.rvtFormat.lod,
                },
            ];
            return parameters;
        },
        // ifc格式
        getIfcParameters() {
            const parameters = [
                {
                    key: '-assembly',
                    value: this.ifcFormat.assembly.toString(),
                },
                {
                    key: '-noedgeline',
                    value: this.ifcFormat.noedgeline.toString(),
                },
              {
                    key: '-exportTexture',
                    value: this.ifcFormat.exportTexture.toString(),
                },
            ];
            return parameters;
        },
        // nwd格式
        getNwdParameters() {
            const parameters = [
                {
                    key: '-recalcuv',
                    value: this.nwdFormat.recalcuv.toString(),
                },
                {
                    key: '-noedgeline',
                    value: this.nwdFormat.noedgeline.toString(),
                },
                {
                    key: '-mergevertex',
                    value: this.nwdFormat.mergevertex.toString(),
                },
            ];
            return parameters;
        },
        // skp格式
        getSkpParameters() {
            const parameters = [
                {
                    key: '-isExportLineSet',
                    value: this.skpFormat.isExportLineSet.toString(),
                },
            ];
            return parameters;
        },
      lodConvert() {
          if(this.fileFormat === 'nwd') {
            document.getElementsByClassName('format-config-list')[0].hidden = true;
          }
        },
      obvConvert() {
        if(this.fileFormat === 'nwd') {
          document.getElementsByClassName('format-config-list')[0].hidden = false;
        }
      }
    },
    mounted() {
        // 查询该格式是否拥有lod转换
        this.isHasJobTypes();
        // 初始化配置选项
        this.reDefault();
    },
};
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.configInfo
  .top-title
    margin-bottom 10px
  .config-container
    line-height 1.5
    li
      display flex
      align-items center
      height 28px
      margin-left 8px
    .format-config-list
      li
        margin-top 15px
        .el-input
          width 200px
    .radio-container
      display flex
      margin-right 10px
</style>



// WEBPACK FOOTER //
// src/pages/devCenter/consoleLab/components/configTabs.vue